/**
 * 判断是否为编辑器
 */
function isElementInViewport(el, root = document.body) {
    // 父元素当前滚动到的位置
    const { scrollTop } = root;
    // 子元素的位置 和 高度
    const { offsetTop, clientHeight } = el;
    // 如果滚动的距离，还没超过子元素的底部，子元素就是在可视区域内
    return scrollTop < offsetTop + clientHeight;
}

export { isElementInViewport };
